import { Col, Form, ModalFooter, Row } from 'react-bootstrap';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Button } from '../../../../../../common/components';
import { getFormValues, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { CommunicationsBox } from '../CommuicationsBox/CommunicationsBox';
import { isBroker, isBrokerOrganisation } from '../../../../../auth/redux/authActions';
import UpgradesBox from '../UpgradesBox/UpgradesBox';
import { MarketingBox } from '../MarketingBox/MarketingBox';
import { Declaration } from '../Declaration/Declaration';
import { PaymentDetails } from '../PaymentDetails/PaymentDetails';
import './IssuePolicyForm.scss';
import { FailedSanctions } from '../../../LeisureTravelForm/Components/FailedSanctions/FailedSanctions';

const showEmailAlert = (values) => {
  if (!values?.data?.attributes?.metadata?.adults) {
    // product without adults array
    return false;
  }

  const emailAdult = !!values?.data.attributes.metadata.adults?.[0]?.email;

  const commEmailCheckbox =
    values?.data?.attributes.metadata.communications?.email ?? false;

  return commEmailCheckbox === true && !emailAdult;
};

const IssuePolicyForm = ({
  addOnDefinitions,
  benefits,
  brokerType,
  boltonsInfo,
  calculatedPremium,
  channelType,
  customer,
  declarations,
  haveBoltonsChanged,
  isGoldUpgraded,
  isIssuing,
  isMarketingEnabled,
  isInsuranceMarketingOptionsEnabled,
  isCarInsuranceMarketingEnabled,
  isHomeInsuranceMarketingEnabled,
  isMta,
  isPremiumAdjusting,
  isSaving,
  isUpdatingPremiumIndication,
  isValid,
  onCancel,
  onCalculate,
  onIssue,
  onUpgradeToGold,
  onRedirectToIssued,
  salesChannel,
  selectedPremium,
  selectedOptions,
  showBoltons,
  showUpgrades,
  showUpgradeToGold,
  upgradeInfo,
  formValues,
  submitting,
  dispatch,
  change,
  handleSubmit,
  productCode,
  failedSanctions,
  hasFailedSanctions,
}) => {
  const travelDispute = formValues?.data?.attributes?.metadata.options?.travel_dispute;
  const endSupplier =
    formValues?.data?.attributes?.metadata?.options?.end_supplier_failure;
  const smartLuggage = formValues?.data?.attributes?.metadata?.options?.smart_luggage;

  useEffect(
    () => {
      const travelDisputeChange =
        travelDispute !== undefined && travelDispute !== selectedOptions.travel_dispute;
      const endSupplierChange =
        endSupplier !== undefined && endSupplier !== selectedOptions.end_supplier_failure;
      const smartLuggageChange =
        smartLuggage !== undefined && smartLuggage !== selectedOptions.smart_luggage;
      if (travelDisputeChange || endSupplierChange || smartLuggageChange) {
        const newOptions = {
          ...selectedOptions,
          travel_dispute: travelDispute,
          end_supplier_failure: endSupplier,
          smart_luggage: smartLuggage,
        };

        onCalculate(newOptions);
      }
    },
    [travelDispute, endSupplier, smartLuggage, onCalculate, selectedOptions],
  );

  const showAlertEmail = showEmailAlert(formValues);

  const toggleRefund = (e) => {
    const newValue = e.currentTarget.checked ? '' : 'no refund';

    if (e.currentTarget.checked) {
      dispatch(change('meta.payment_type', newValue));
    } else {
      dispatch(change('meta.payment_type', newValue));
    }
  };

  const onCommunicationOptionsChange = (e, type) => {
    const disablePost =
      (isBroker() || isBrokerOrganisation()) && type === 'email' && e === true;
    if (disablePost) {
      dispatch(change('data.attributes.metadata.communications.post', false));
    }

    if (type === 'sms') {
      dispatch(change('meta.send_sms', e));
    }
  };

  const handleUpgradeToGold = () => {
    if (!isGoldUpgraded) {
      dispatch(change('data.attributes.metadata.options.travel_dispute', false));
      dispatch(change('data.attributes.metadata.options.end_supplier_failure', false));
      dispatch(change('data.attributes.metadata.options.smart_luggage', false));
    }

    onUpgradeToGold();
    // if (premium) {
    //   dispatch(change('data.relationships.premium.data.id', premium.id));
    //   dispatch(change('meta.amount', premium.attributes.gross));
    // }
  };

  return (
    <Form horizontal className="issue-policy-form" onSubmit={handleSubmit(onIssue)}>
      <UpgradesBox
        addOnDefinitions={addOnDefinitions}
        benefits={benefits}
        boltonsInfo={boltonsInfo}
        show={showUpgrades}
        showBoltonOptions={showBoltons}
        showUpgrade={showUpgradeToGold}
        upgradeInfo={upgradeInfo}
        isPremiumAdjusting={isPremiumAdjusting}
        isSaving={isSaving}
        isGoldUpgraded={isGoldUpgraded}
        isMta={isMta}
        onUpgradeToGold={handleUpgradeToGold}
      />

      <CommunicationsBox
        show={productCode !== 'SL'}
        customer={customer}
        onCommunicationOptionsChange={onCommunicationOptionsChange}
        showAlertEmail={showAlertEmail}
      />

      <MarketingBox
        isMarketingEnabled={isMarketingEnabled}
        isInsuranceMarketingOptionsEnabled={isInsuranceMarketingOptionsEnabled}
        isCarInsuranceMarketingEnabled={isCarInsuranceMarketingEnabled}
        isHomeInsuranceMarketingEnabled={isHomeInsuranceMarketingEnabled}
      />
      {!isValid && (
        <Row>
          <Col sm={12}>
            <h4>Not ready for issuing</h4>
          </Col>
        </Row>
      )}
      <Declaration
        isValid={isValid}
        channelType={channelType}
        declarations={declarations}
      />
      <PaymentDetails
        isValid={isValid}
        calculatedPremium={calculatedPremium}
        selectedPremium={selectedPremium}
        haveBoltonsChanged={haveBoltonsChanged}
        isGoldUpgraded={isGoldUpgraded}
        isRefund={formValues?.meta.refund}
        brokerType={brokerType}
        salesChannel={salesChannel}
        paymentType={formValues?.meta.payment_type}
        isPremiumUpdating={isSaving || isPremiumAdjusting || isUpdatingPremiumIndication}
        onToggleRefund={toggleRefund}
        onRedirectToIssued={onRedirectToIssued}
      />

      <FailedSanctions
        adults={failedSanctions?.adults ?? []}
        children={failedSanctions?.children ?? []}
      />
      <ModalFooter>
        <Button
          className="pull-left settings-button"
          bsStyle="default"
          leftIcon="times"
          label="Close"
          handleClick={onCancel}
        />
        <Button
          bsStyle="primary"
          type={'submit'}
          id={'issue-policy-modal-button'}
          isLoading={submitting}
          disabled={isIssuing || isSaving || showAlertEmail || hasFailedSanctions}
          label="Issue Policy"
        />
      </ModalFooter>
    </Form>
  );
};

const getLeisureTravelInitialValues = (
  productCode,
  selectedPremium,
  smsNumber,
  communications,
  options,
  sanctionResult,
  adults,
  children,
) => {
  const newAdults = adults?.map((adult, index) => {
    if (index === 0) {
      return {
        dob: adult.dob,
        title: adult.title,
        first_name: adult.first_name,
        last_name: adult.last_name,
        email: adult.email,
        marketing_options: Array.isArray(adult.marketing_options)
          ? {}
          : adult.marketing_options,
        metadata: {
          marketing_additional_info: Array.isArray(
            adult?.metadata?.marketing_additional_info,
          )
            ? {}
            : adult?.metadata?.marketing_additional_info,
        },
        sanction_id: adult.sanction_id,
        sanctions_check: adult.sanctions_check,
        sanction_result: adult.sanction_result,
      };
    }
    return {
      dob: adult.dob,
      title: adult.title,
      first_name: adult.first_name,
      last_name: adult.last_name,
      sanction_id: adult.sanction_id,
      sanctions_check: adult.sanctions_check,
      sanction_result: adult.sanction_result,
    };
  });

  const newChild = children?.map((child) => ({
    dob: child.dob,
    title: child.title,
    first_name: child.first_name,
    last_name: child.last_name,
    sanction_id: child.sanction_id,
    sanctions_check: child.sanctions_check,
    sanction_result: child.sanction_result,
  }));
  return {
    data: {
      attributes: {
        metadata: {
          communications: {
            email: !!communications?.email,
            sms: !!communications?.sms,
            post: !!communications?.post,
          },
          adults: newAdults,
          children: newChild,
          options,
          storage: {},
          sanctions_result: sanctionResult,
        },
      },
    },
    relationships: {
      premium: {
        data: {
          id: selectedPremium?.id,
        },
      },
    },
    meta: {
      product_code: productCode,
      sms_number: smsNumber,
      refund: true,
    },
  };
};

const getDefaultInitialValues = (
  productCode,
  selectedPremium,
  smsNumber,
  communications,
) => {
  return {
    data: {
      attributes: {
        metadata: {},
      },
      relationships: {
        premium: {
          data: {
            id: selectedPremium?.id,
          },
        },
      },
    },
    meta: {
      product_code: productCode,
      send_sms: communications?.sms ?? false,
      sms_number: smsNumber,
      refund: true,
    },
  };
};

const getInitialValues = (
  productCode,
  communications,
  options,
  sanctionResult,
  adults,
  children,
  selectedPremium,
  smsNumber,
) => {
  if (productCode === 'TRAV') {
    return getLeisureTravelInitialValues(
      productCode,
      selectedPremium,
      smsNumber,
      communications,
      options,
      sanctionResult,
      adults,
      children,
    );
  }
  return getDefaultInitialValues(productCode, selectedPremium, smsNumber, communications);
};

export default compose(
  connect(
    (state, ownProps) => {
      const {
        sanctions_result: sanctionResult,
        adults,
        children,
        options,
        communications,
      } = ownProps.application?.data?.attributes?.metadata ?? {};

      return {
        form: ownProps.formName,
        initialValues: getInitialValues(
          ownProps.productCode,
          communications,
          options,
          sanctionResult,
          adults,
          children,
          ownProps.selectedPremium,
          ownProps.smsNumber,
        ),
        formValues: getFormValues(ownProps.formName)(state),
      };
    },
    null,
  ),
  reduxForm({}),
)(IssuePolicyForm);
